import { render, staticRenderFns } from "./BookingRoutes.vue?vue&type=template&id=13587bb6&scoped=true&"
import script from "./BookingRoutes.vue?vue&type=script&lang=js&"
export * from "./BookingRoutes.vue?vue&type=script&lang=js&"
import style0 from "./BookingRoutes.vue?vue&type=style&index=0&id=13587bb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13587bb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13587bb6')) {
      api.createRecord('13587bb6', component.options)
    } else {
      api.reload('13587bb6', component.options)
    }
    module.hot.accept("./BookingRoutes.vue?vue&type=template&id=13587bb6&scoped=true&", function () {
      api.rerender('13587bb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/booking/BookingRoutes.vue"
export default component.exports